<template>
  <el-dialog
    append-to-body
    :visible.sync="dialogVisible"
    width="270px"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :before-close="handleClose"
    class="booking-success-dialog"
    center
  >
    <div class="cont-wrap">
      <p class="dialog-title">
        <img src="../../../assets/images/dui-icon.png" alt="" />
        <span>恭喜您预约成功</span>
      </p>
      <div v-if="assistantInfo.haveAssistant" class="qrcode-wrap">
        <p class="tips">扫码添加下方老师微信</p>
        <img
          class="qrcode"
          :src="assistantInfo.img_url + '?imageView2/0/w/300'"
          alt=""
        />
      </div>
      <button class="share-btn" @click="shareUrl" v-preventReClick>分享</button>
    </div>
  </el-dialog>
</template>

<script>
import { copyPageUrl, clipboard } from "@saas/components/src/utils/utils";
export default {
  data: function () {
    return {
      dialogVisible: false,
      assistantInfo: {},
    };
  },
  methods: {
    handleClose() {
      this.dialogVisible = false;
      setTimeout(() => {
        this.assistantInfo = {};
      }, 100);
    },
    openDialog(assistantInfo) {
      this.assistantInfo = assistantInfo;
      this.dialogVisible = true;
    },
    shareUrl() {
      if (window.isElectron) {
        let content = `${process.env.VUE_APP_SAAS_WEB_URL}/product-detail/${this.$route.params.id}`;
        clipboard(content, () => {
          this.$showToast("已复制课程链接，粘贴即可分享");
          this.handleClose();
        });
      } else {
        copyPageUrl();
        this.handleClose();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.booking-success-dialog {
  --booking-success-dialog-bg: var(--mg-bg-elevated, #ffffff);
  --booking-success-dialog-border: var(--mg-border-subtle, #e5e6e8);
  --booking-success-dialog-shadow: 0px 2px 16px 0px rgba(102, 116, 107, 0.1);
  --booking-success-dialog-title: var(--mg-text-primary, #0d1400);
  --booking-success-dialog-close: var(--mg-text-muted, #4e5969);

  ::v-deep .el-dialog {
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    margin: 0 !important;
    background: var(--booking-success-dialog-bg);
    border-radius: 18px;
    box-shadow: var(--booking-success-dialog-shadow);
    border: 1px solid var(--booking-success-dialog-border);
  }
  ::v-deep .el-dialog__close {
    color: var(--booking-success-dialog-close);
    font-size: 14px;
    font-weight: bold;
  }
  ::v-deep .el-dialog__headerbtn {
    top: 10px;
    right: 12px;
  }
  ::v-deep .el-dialog__body,
  .el-dialog__header {
    padding: 0 !important;
  }
  ::v-deep .el-dialog__header {
    padding: 0 !important;
  }
  .cont-wrap {
    padding: 30px 0 26px;
  }
  .dialog-title {
    display: flex;
    align-items: center;
    justify-content: center;
    img {
      width: 16px;
      height: 16px;
      margin-right: 6px;
    }
    font-weight: 500;
    font-size: 16px;
    color: var(--booking-success-dialog-title);
    line-height: 22px;
  }
  .qrcode-wrap {
    .tips {
      font-size: 14px;
      color: var(--booking-success-dialog-title);
      line-height: 22px;
      margin-top: 6px;
      text-align: center;
    }
    .qrcode {
      width: 200px;
      max-height: 400px;
      margin: 18px auto;
    }
  }
  .share-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 192px;
    height: 36px;
    font-weight: 600;
    font-size: 14px;
    color: #ffffff;
    line-height: 22px;
    background: linear-gradient(132deg, #00eb81 0%, #00c89d 100%);
    border-radius: 8px;
    margin: 0 auto;
    margin-top: 30px;
  }
}

html.dark .booking-success-dialog,
html.theme-dark .booking-success-dialog,
html[data-theme="dark"] .booking-success-dialog,
#app.dark .booking-success-dialog,
#app.theme-dark .booking-success-dialog {
  --booking-success-dialog-bg: var(--mg-bg-elevated, var(--card-bg));
  --booking-success-dialog-border: var(--mg-border-subtle, var(--border-subtle));
  --booking-success-dialog-shadow: 0 16px 36px rgba(0, 0, 0, 0.28);
  --booking-success-dialog-title: var(--mg-text-primary, var(--text-primary));
  --booking-success-dialog-close: var(--mg-text-muted, var(--text-muted));
}
</style>
